<div id="selection" class="registration container">
  <form #waveForm="ngForm" name="waveForm" (ngSubmit)="forward(waveForm)" ng-class="{'form-complete': invitationCtrl.isFormCompleted}" novalidate autocomplete="off" appScrollToInvalid>
    <h1>{{ 'copy.label.SELECTION.header' | copy | async }}</h1>
    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.SELECTION.please' | copy | async }} <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <div class="card-body w-100">
          <div class="radio-group w-100">
            <div class="w-100 required">
              <mat-radio-group class="w-100" [(ngModel)]="attendee.$mtcWaveName" #waveOption="ngModel" name="waveOption" required (change)="radioChange($event)">
                <mat-radio-button *ngFor="let item of programOptionRadios" [disabled]="item.disabled"  [value]="item.capacityName">{{item.display}}</mat-radio-button>                
                <div class="w-100">
                  <mat-error><app-validation  [object]="waveOption" isRequired=true pattern="email"></app-validation></mat-error>
                </div>
              </mat-radio-group>
            </div>
          </div>
          <p class="mt-4" >
            <span [innerHTML]="'copy.label.SELECTION.noteA' |copy |async"></span><br/>
            <span [innerHTML]="'copy.label.SELECTION.noteB' |copy |async"></span>
          </p>
        </div>
      </article>
    </section>

    <div class="button_group d-flex flex-row justify-content-between">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
      </button>
      <button class="inputSubmit ms-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>
